import { authRoles } from '../store/actionreducers/auth/auth'

export const fuseNavigationConfig = [
    {
        'id': 'applications',
        'title': '基礎功能',
        'type': 'group',
        'icon': 'apps',
        'children': [
            {
                id: 'profile',
                title: '個人資料',
                type: 'item',
                icon: 'person',
                auth: authRoles.user,
                url: '/profile',
            },
        ],
    },
    {
        'id': 'human',
        'title': '管理功能',
        'type': 'group',
        'icon': 'apps',
        'children': [
            {
                id: 'medical',
                title: '合作夥伴列表',
                type: 'item',
                icon: 'local_hospital',
                auth: authRoles.cc,
                url: '/apps/medical',
            },
            // institution medical list for adminMedical
            {
                id: 'institutionMedical',
                title: '本院醫療顧問列表',
                type: 'item',
                icon: 'local_hospital',
                auth: authRoles.adminMedical,
                url: '/apps/institutionMedical',
            },
            {
                id: 'vips',
                title: '會員列表',
                type: 'item',
                icon: 'account_box',
                auth: [...authRoles.cc],
                url: '/apps/vip/all',
            }
        ],
    },
    {
        'id': 'dashboard',
        'title': '服務概況',
        'type': 'group',
        'icon': 'apps',
        'children': [
            // {
            //     id: 'survey',
            //     title: '問卷發送狀況',
            //     type: 'item',
            //     icon: 'mail',
            //     auth: authRoles.cc,
            //     url: '/apps/survey'
            // },
            {
                id: 'surveyCount',
                title: '內嵌問卷統計',
                type: 'item',
                icon: 'card_membership',
                auth: authRoles.cc,
                url: '/apps/surveyCount',
            },
            {
                id: 'feedback',
                title: '意見回饋',
                type: 'item',
                icon: 'insert_comment',
                auth: authRoles.cc,
                url: '/apps/feedback',
            },
        ],
    },
    {
        'id': 'services',
        'title': '服務管理',
        'type': 'group',
        'icon': 'apps',
        'children': [
            // {
            //     id: 'trialVips',
            //     title: '試用會員列表',
            //     type: 'item',
            //     icon: 'card_membership',
            //     auth: authRoles.sales,
            //     url: '/apps/trialVip/all'
            // },
            // {
            //     id: 'applyMedicals',
            //     title: '待審核醫生列表',
            //     type: 'item',
            //     icon: 'account_box',
            //     auth: authRoles.medical,
            //     url: '/apps/applyMedical/all'
            // },
            {
                id: 'mission',
                title: '任務列表',
                type: 'item',
                icon: 'assignment',
                auth: [...authRoles.cc],
                url: '/apps/mission',
            },
            {
                id: 'institution-mission',
                title: '任務列表',
                type: 'item',
                icon: 'assignment',
                auth:  authRoles.adminMedical,
                url: '/apps/institutionMission',
            },
            {
                id: 'new-calender',
                title: '急診醫師排班',
                type: 'item',
                icon: 'today',
                auth: [...authRoles.cc, ...authRoles.adminMedical, ...authRoles.admin],
                url: '/apps/new-calendar',
            },
            {
                id: 'specialist-mission',
                title: '專科醫師排班',
                type: 'item',
                icon: 'today',
                auth: authRoles.cc,
                url: '/apps/specialist-mission',
            },
            {
                id: 'institution-specialist-mission',
                title: '專科醫師排班',
                type: 'item',
                icon: 'today',
                auth: authRoles.adminMedical,
                url: '/apps/institution-specialist',
            },
            {
                id: 'callRecord',
                title: '客服電話紀錄',
                type: 'item',
                icon: 'call',
                auth: authRoles.cc,
                url: '/apps/call-record',
            },
        ],
    },
]




// WEBPACK FOOTER //
// ./src/fuse-configs/fuseNavigationConfig.js